import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSecretPhrase: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSecretPhrase"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM6 8H11V10H6V8ZM13 8V10H18V8H13ZM6 11H11V13H6V11ZM13 11V13H18V11H13ZM6 14H11V16H6V14ZM13 14V16H18V14H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSecretPhrase;
